<template>
  <Container type="card-full">
    <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div>
    <vggrid ref="xGrid" :list="list" tableheight="700" flexname=""
             :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total"
            :needBlackRow="false":needPopMenu="true" :canbeEdit="true"
            @cellClick="cellClick" @pagechange="pagechange">
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'lcIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'lccode', fieldtype: 'C', title: '编号',calculExpr:'', editRender: { name: 'input'}},
          { field: 'lcname', fieldtype: 'C', title: '名称',calculExpr:'',editRender: { name: 'input'}},
          { field: 'lcinvalid', fieldtype: 'B', title: '作废',syscode: 'lcinvalid',calculExpr:'',editRender: { name: 'select', options: []}},
          { field: 'lcremark', fieldtype: 'C',title: '备注',calculExpr:'',editRender: { name: 'input'}}
        ],
        lc: {},
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          currPage: 1,
          pageSize: 20
        }
      }
    },
    created () {
      this.$on('SAV', () => this.addOrEdit())
      this.$on('DEL', () => this.delLc())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getLcList()
    },
    mounted () {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async delLc () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/basic/lc/delLc',
            method: "post",
            data: this.lc
          })
          if (data.issuccess===1) {
            this.getLcList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！')
          }
        })
      },
      async cellClick (row) {
        this.lc = row.row
      },
      async pagechange (lcPage) {
        this.query.currPage = lcPage.currentPage
        this.query.pageSize = lcPage.pageSize
        this.getLcList()
      },
      async addOrEdit () {
        let model = this.$refs.xGrid.$refs.xGrid.getRecordset()
        model.comid = this.$store.getters.loginUser.usercomid
        let data = await request({
          url: '/basic/lc/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          await this.getLcList()
          this.$message.success('保存成功！')
        } else {
          this.$message.error('保存失败!')
        }
      },
      async getLcList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/basic/lc/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
